'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { useQuery } from '@tanstack/react-query';
import { CheckboxesFilter } from '../../../filter/fields/jobportal-filter-checkboxes';
import { useJobportalCoursesStore } from '@eliadmin/core/src/stores/jobportal-courses-store';
import { fetchCourseCategories } from '@eliadmin/core/src/api/courses/coursers-api';

export const CoursesFilterContent = () => {
  const { t } = useTranslations();
  const locale = useLocaleStore(s => s.currentLocale);

  const { setFilter, filter } = useJobportalCoursesStore();

  const { data: categories } = useQuery({
    queryKey: ['CacheKey.JOBPORTAL_COURSES_CATEGORIES', locale],
    staleTime: 5 * 60 * 1000,
    queryFn: () =>
      fetchCourseCategories({ locale, query: {} }).then(r =>
        r.data.map(g => ({ label: g.name, value: g.id.toString() })),
      ),
  });

  return (
    <>
      {categories && (
        <CheckboxesFilter
          title={t('text176')}
          search
          searchPlaceholder={'Vyhľadať kategóriu'}
          sortBySelected
          options={categories}
          selectedOptions={
            categories
              .filter(val => filter.categories?.find(val2 => val2 === val.value))
              .map(val3 => val3.value) ?? []
          }
          onChange={(newCategories: any) => {
            setFilter({ categories: newCategories });
          }}
        />
      )}
    </>
  );
};
